var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (ngRequired, required) {pug_mixins["centered-content"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv" + (pug.attrs(pug.merge([{"class": "centered-content","layout": "row"},attributes]), true)) + "\u003E\u003Cdiv class=\"content\" layout=\"column\" layout-align=\"start stretch\" flex flex-md=\"90\" flex-lg=\"80\" flex-gt-lg=\"70\" flex-offset-md=\"5\" flex-offset-lg=\"10\" flex-offset-gt-lg=\"15\"\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
};
pug_mixins["contentful-component"] = pug_interp = function(component){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-if", "" + component + ".fields.type === 'wide'", true, true)) + "\u003E\u003Cicon-panel" + (" class=\"wide-panel\""+pug.attr("panel", "" + component, true, true)) + "\u003E\u003C\u002Ficon-panel\u003E\u003C\u002Fdiv\u003E";
pug_mixins["centered-content"].call({
block: function(){
pug_html = pug_html + "\u003Cicon-panel" + (" class=\"standard-panel\""+pug.attr("panel", "" + component, true, true)) + "\u003E\u003C\u002Ficon-panel\u003E";
},
attributes: {"ng-if": pug.escape("" + component + ".fields.type !== 'wide'")}
});
};





























pug_mixins["required-radio-container"] = pug_interp = function(name, model, layout){
var block = (this && this.block), attributes = (this && this.attributes) || {};
ngRequired = attributes['ng-required']
required = !ngRequired
layout = layout || 'row'
pug_html = pug_html + "\u003Cmd-radio-group" + (pug.attr("ng-required", ngRequired, true, true)+pug.attr("ng-model", model, true, true)+pug.attr("layout", layout, true, true)+pug.attr("ng-class", "'" + name + "'", true, true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003Chelp-mate" + (pug.attr("topic", name, true, true)) + "\u003E\u003C\u002Fhelp-mate\u003E\u003C\u002Fmd-radio-group\u003E\u003Cinput-container class=\"hidden-input\"\u003E\u003Cinput" + (pug.attr("ng-required", ngRequired, true, true)+pug.attr("required", required, true, true)+pug.attr("name", name, true, true)+pug.attr("ng-model", model, true, true)+" ng-show=\"false\" aria-label=\"require\"") + "\u003E\u003C\u002Finput-container\u003E";
};








pug_mixins["required-select"] = pug_interp = function(name, model, label){
var block = (this && this.block), attributes = (this && this.attributes) || {};
label = label || name
pug_html = pug_html + "\u003Cinput-container" + (pug.attr("label", label, true, true)) + "\u003E\u003Cmd-select" + (" class=\"required-select big-list\""+pug.attr("ng-model", model, true, true)+pug.attr("ng-class", "'" + name + "'", true, true)+pug.attr("placeholder", label, true, true)+pug.attr("aria-label", label, true, true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fmd-select\u003E\u003Cinput-container class=\"hidden-input\"\u003E\u003Cinput" + (pug.attr("required", true, true, true)+pug.attr("name", name, true, true)+pug.attr("ng-model", model, true, true)+" ng-show=\"false\" aria-label=\"require\"") + "\u003E\u003C\u002Finput-container\u003E\u003C\u002Finput-container\u003E";
};










































































pug_mixins["rateDisplay"] = pug_interp = function(rate){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + (pug.escape(null == (pug_interp = rate) ? "" : pug_interp)) + "\u003Cimg src=\"\u002Ficons\u002Ficon-percent-pa.svg\" alt=\"percentage pa\"\u003E";
};












pug_mixins["allButtonActions"] = pug_interp = function(item){
var block = (this && this.block), attributes = (this && this.attributes) || {};
var label = "{{ vm.label(" + item + ") }}"
var ariaLabel = "{{vm.ariaLabel(" + item + ")}}"
var addNameClass = "vm.addNameClass(" + item + ")"
var uiSrefOpts = "vm.navActionOpts(" + item + ")"
var refAction = "{{ vm.navRefAction(" + item + ") }}"
var gaClick = "{{ vm.navGaClick(" + item + ") }}"
pug_html = pug_html + "\u003Cmd-button" + (pug.attr("ng-if", "vm.actionType('click', " + item + ")", true, true)+pug.attr("ng-class", addNameClass, true, true)+pug.attr("ng-click", "vm.navClickAction(" + item + ")", true, true)+pug.attr("aria-label", ariaLabel, true, true)+pug.attr("ga-click", gaClick, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = label) ? "" : pug_interp)) + "\u003C\u002Fmd-button\u003E\u003Cmd-button" + (pug.attr("ng-if", "vm.actionType('sref', " + item + ")", true, true)+pug.attr("ng-class", addNameClass, true, true)+pug.attr("ui-sref", refAction, true, true)+pug.attr("ui-sref-opts", uiSrefOpts, true, true)+pug.attr("aria-label", ariaLabel, true, true)+pug.attr("ga-click", gaClick, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = label) ? "" : pug_interp)) + "\u003C\u002Fmd-button\u003E\u003Cmd-button" + (pug.attr("ng-if", "vm.actionType('href', " + item + ")", true, true)+pug.attr("ng-class", addNameClass, true, true)+pug.attr("ng-href", refAction, true, true)+pug.attr("aria-label", ariaLabel, true, true)+pug.attr("ga-click", gaClick, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = label) ? "" : pug_interp)) + "\u003C\u002Fmd-button\u003E";
};
pug_html = pug_html + "\u003Centity-name value=\"{{vm.selectedEntity.name}}\"\u003E\u003C\u002Fentity-name\u003E\u003Cmd-toolbar top role=\"navigation\" if-media-size=\"gt-sm\"\u003E\u003Cdiv class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-around center\"\u003E\u003Cdiv class=\"brand-information\"\u003E\u003Ca class=\"mast-logo-home\" ui-sref=\"home\"\u003E\u003C\u002Fa\u003E\u003Ctenant-anchor anchor-id=\"contact.telephone.main\"\u003E\u003C\u002Ftenant-anchor\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"filler\" flex\u003E&nbsp;\u003C\u002Fdiv\u003E\u003Cdiv class=\"dynamic-nav-item\" ng-if=\"vm.navigationLoaded\" ng-repeat=\"navItem in vm.navItemsDesktop track by navItem.name\" ng-switch=\"navItem.type\"\u003E\u003Cdiv class=\"button-holder\" ng-switch-when=\"button\" ng-class=\"vm.tabHighlight(navItem)\"\u003E";
pug_mixins["allButtonActions"]('navItem');
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cmd-menu-bar ng-switch-when=\"menu\" ng-class=\"vm.addAuxiliaryClasses(navItem)\"\u003E\u003Cmd-menu class=\"button-holder\" md-position-mode=\"target-right bottom\" md-offset=\"{{ vm.menuOffset(navItem) }}\" ng-class=\"vm.tabHighlight(navItem)\"\u003E\u003Cspan\u003E";
pug_mixins["allButtonActions"]('navItem');
pug_html = pug_html + "\u003Cmd-button class=\"dropdown\" ng-class=\"vm.addNameClass(navItem, 'menu')\" ng-click=\"vm.toggleMenu($mdMenu, $mdMenuIsOpen, $event)\" aria-label=\"{{ vm.ariaLabel(navItem, 'menu') }}\"\u003E \u003Cmd-icon\u003Earrow_drop_down\u003C\u002Fmd-icon\u003E\u003C\u002Fmd-button\u003E\u003C\u002Fspan\u003E\u003Cmd-menu-content ng-class=\"vm.addNameClass(navItem, 'sub-menu')\" width=\"1\" ng-mouseleave=\"$mdMenu.close()\"\u003E\u003Cmd-menu-item ng-repeat=\"navMenuItem in navItem.menuItems\" ng-if=\"vm.isRendered(navMenuItem)\" ng-class=\"vm.addAuxiliaryClasses(navMenuItem)\"\u003E";
pug_mixins["allButtonActions"]('navMenuItem');
pug_html = pug_html + "\u003C\u002Fmd-menu-item\u003E\u003C\u002Fmd-menu-content\u003E\u003C\u002Fmd-menu\u003E\u003C\u002Fmd-menu-bar\u003E\u003Cdiv class=\"nothing\" ng-switch-default\u003E❌ unknown type {{ navItem.type }} ({{navItem.name}})\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cmd-menu-bar class=\"user\" ng-if=\"vm.navigationLoaded &amp;&amp; vm.isRendered(vm.authNavItems)\"\u003E\u003Cmd-button class=\"sign-up\" ng-if=\"vm.isRendered(vm.authNavItems.buttons.signUp)\" ui-sref=\"{{ vm.navRefAction(vm.authNavItems.buttons.signUp) }}\" ga-click=\"{{ vm.navGaClick(vm.authNavItems.buttons.signUp) }}\" aria-label=\"{{vm.ariaLabel(vm.authNavItems.buttons.signUp.desktop)}}\"\u003E{{ vm.label(vm.authNavItems.buttons.signUp.desktop) }}\u003C\u002Fmd-button\u003E\u003Cmd-button class=\"login\" ng-if=\"vm.isRendered(vm.authNavItems.buttons.login)\" ng-click=\"vm.navClickAction(vm.authNavItems.buttons.login)\" ga-click=\"{{ vm.navGaClick(vm.authNavItems.buttons.login) }}\" aria-label=\"{{vm.ariaLabel(vm.authNavItems.buttons.login.desktop)}}\"\u003E{{ vm.label(vm.authNavItems.buttons.login.desktop) }}\u003C\u002Fmd-button\u003E\u003C\u002Fmd-menu-bar\u003E\u003Cmd-menu-bar ng-if=\"vm.isLoggedIn\"\u003E\u003Cmd-menu\u003E\u003Cmd-button class=\"account\" ng-click=\"vm.toggleMenu($mdMenu, $mdMenuIsOpen, $event)\" aria-label=\"User Menu\"\u003E{{ vm.preferredName }}\u003C\u002Fmd-button\u003E\u003Cmd-menu-content class=\"account-menu-content\" width=\"3\"\u003E\u003Cmd-menu-item ng-if=\"vm.preferredName\"\u003E\u003Cdiv class=\"account-email\"\u003E{{ vm.currentUser.email }}\u003C\u002Fdiv\u003E\u003C\u002Fmd-menu-item\u003E\u003Cmd-divider ng-if=\"vm.preferredName\"\u003E\u003C\u002Fmd-divider\u003E\u003Cmd-menu-item\u003E\u003Cmd-button class=\"change-preferred-name\" ng-click=\"vm.showChangePreferredNamePrompt($event)\" aria-label=\"Preferred name\"\u003EPreferred name\u003C\u002Fmd-button\u003E\u003C\u002Fmd-menu-item\u003E\u003Cmd-menu-item ng-if=\"vm.entities.length &gt; 1\"\u003E\u003Cmd-menu\u003E\u003Cmd-button class=\"entity\" ng-click=\"vm.toggleMenu($mdMenu, $mdMenuIsOpen, $event)\" aria-label=\"Account\"\u003EAccount\u003C\u002Fmd-button\u003E\u003Cmd-menu-content width=\"3\"\u003E\u003Cmd-menu-item type=\"radio\" ng-repeat=\"entity in vm.entities track by $index\" ng-value=\"$index\" ng-model=\"vm.selected\"\u003E{{ entity.name }}\u003C\u002Fmd-menu-item\u003E\u003C\u002Fmd-menu-content\u003E\u003C\u002Fmd-menu\u003E\u003C\u002Fmd-menu-item\u003E\u003Cmd-menu-item\u003E\u003Cmd-button class=\"logout\" ng-click=\"vm.logout()\" aria-label=\"Logout\"\u003ELogout\u003C\u002Fmd-button\u003E\u003C\u002Fmd-menu-item\u003E\u003C\u002Fmd-menu-content\u003E\u003C\u002Fmd-menu\u003E\u003C\u002Fmd-menu-bar\u003E\u003C\u002Fdiv\u003E\u003C\u002Fmd-toolbar\u003E\u003Cmd-sidenav class=\"md-sidenav-left md-whiteframe-z2\" md-component-id=\"left\" md-swipe-left=\"vm.closeSidenav()\" if-media-size=\"xs sm\"\u003E\u003Cmd-list layout=\"column\"\u003E\u003Cmd-item\u003E\u003Ca class=\"mast-logo-home\" ng-click=\"vm.closeSidenav()\" ui-sref=\"home\"\u003E\u003C\u002Fa\u003E\u003Cdiv class=\"account-email\"\u003E{{ vm.currentUser.email }}\u003C\u002Fdiv\u003E\u003C\u002Fmd-item\u003E\u003Cdiv class=\"group\" ng-if=\"vm.navigationLoaded\" ng-repeat=\"group in vm.navItemsMobile track by group.group\"\u003E\u003Cmd-divider\u003E\u003C\u002Fmd-divider\u003E\u003Cmd-item class=\"md-ink-ripple\" ng-repeat=\"item in group.menuItems track by item.name\" ng-if=\"vm.isRendered(item)\" ng-click=\"vm.closeSidenav()\"\u003E";
pug_mixins["allButtonActions"]('item');
pug_html = pug_html + "\u003C\u002Fmd-item\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"has-entities\" ng-if=\"vm.entities.length &gt; 1\"\u003E\u003Cmd-divider\u003E\u003C\u002Fmd-divider\u003E\u003Cmd-menu-item\u003E\u003Cmd-menu\u003E\u003Cmd-button class=\"entity\" ng-click=\"vm.toggleMenu($mdMenu, $mdMenuIsOpen, $event)\" aria-label=\"Account\"\u003EAccount\u003C\u002Fmd-button\u003E\u003Cmd-menu-content width=\"3\"\u003E\u003Cdiv class=\"entity\" ng-repeat=\"entity in vm.entities track by $index\" ng-click=\"vm.selectEntity($index, true)\"\u003E\u003Cmd-icon ng-if=\"vm.selected === $index\"\u003Echeck_box\u003C\u002Fmd-icon\u003E\u003Cmd-icon ng-if=\"vm.selected !== $index\"\u003Echeck_box_outline_blank\u003C\u002Fmd-icon\u003E\u003Cmd-icon\u003Eperson\u003C\u002Fmd-icon\u003E\u003Cspan\u003E{{ entity.name }}\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fmd-menu-content\u003E\u003C\u002Fmd-menu\u003E\u003C\u002Fmd-menu-item\u003E\u003C\u002Fdiv\u003E\u003Cmd-divider ng-show=\"vm.isLoggedIn\"\u003E\u003C\u002Fmd-divider\u003E\u003Cmd-item class=\"md-ink-ripple\" ng-show=\"vm.isLoggedIn\"\u003E\u003Cmd-button class=\"logout\" ng-click=\"vm.closeSidenav(); vm.logout()\" aria-label=\"Logout\"\u003ELogout\u003C\u002Fmd-button\u003E\u003C\u002Fmd-item\u003E\u003C\u002Fmd-list\u003E\u003C\u002Fmd-sidenav\u003E\u003Cmd-toolbar if-media-size=\"xs sm\"\u003E\u003Cdiv class=\"md-toolbar-tools\"\u003E\u003Cmd-button class=\"md-icon-button sidenav\" hide-gt-sm ng-click=\"vm.openSidenav()\" aria-label=\"Side navigation\"\u003E\u003Ci class=\"material-icons\"\u003Emenu\u003C\u002Fi\u003E\u003C\u002Fmd-button\u003E\u003Cdiv class=\"header-fittext-container\" flex\u003E\u003Cdiv class=\"logo-reverse\" ng-if=\"!vm.title.length\"\u003E\u003C\u002Fdiv\u003E\u003Ch2 class=\"mobile-title\" ng-class=\"vm.titleClass\" data-fittext data-fittext-max=\"inherit\" ng-bind=\"vm.title\"\u003E{{ vm.title }}\u003C\u002Fh2\u003E\u003C\u002Fdiv\u003E\u003Cmd-menu class=\"apply\" md-position-mode=\"target-right bottom\" ng-if=\"vm.navigationLoaded &amp;&amp; vm.isRendered(vm.authNavItems)\"\u003E\u003Cmd-button class=\"sign-up\" ng-click=\"$mdMenu.open($event)\" aria-label=\"Investor\"\u003EInvestor\u003C\u002Fmd-button\u003E\u003Cmd-menu-content width=\"2\" layout-align=\"start start\"\u003E\u003Cmd-menu-item ng-if=\"vm.isRendered(vm.authNavItems.buttons.login)\"\u003E\u003Cmd-button class=\"login\" ng-click=\"vm.navClickAction(vm.authNavItems.buttons.login)\" ga-click=\"{{ vm.navGaClick(vm.authNavItems.buttons.login) }}\" aria-label=\"{{vm.ariaLabel(vm.authNavItems.buttons.login.mobile)}}\"\u003E{{ vm.label(vm.authNavItems.buttons.login.mobile) }}\u003C\u002Fmd-button\u003E\u003C\u002Fmd-menu-item\u003E\u003Cmd-menu-item ng-if=\"vm.isRendered(vm.authNavItems.buttons.signUp)\"\u003E\u003Cmd-button class=\"register-to-invest\" ui-sref=\"{{ vm.navRefAction(vm.authNavItems.buttons.signUp) }}\" ga-click=\"{{ vm.navGaClick(vm.authNavItems.buttons.signUp) }}\" aria-label=\"{{vm.ariaLabel(vm.authNavItems.buttons.signUp.mobile)}}\"\u003E{{ vm.label(vm.authNavItems.buttons.signUp.mobile) }}\u003C\u002Fmd-button\u003E\u003C\u002Fmd-menu-item\u003E\u003C\u002Fmd-menu-content\u003E\u003C\u002Fmd-menu\u003E\u003C\u002Fdiv\u003E\u003C\u002Fmd-toolbar\u003E";}.call(this,"ngRequired" in locals_for_with?locals_for_with.ngRequired:typeof ngRequired!=="undefined"?ngRequired:undefined,"required" in locals_for_with?locals_for_with.required:typeof required!=="undefined"?required:undefined));;return pug_html;};
module.exports = template;